import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";

export const AnalyticsServices = {
  getUtmSummary: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.start_date) queryParams.append("start_date", params.start_date);
    if (params.end_date) queryParams.append("end_date", params.end_date);
    if (params.group_by) queryParams.append("group_by", params.group_by);

    return await commonRequest(
      "get",
      `${Helpers.URL()}/api/admin/analytics/utm-summary?${queryParams.toString()}`,
      {},
      Helpers.token()
    );
  },

  getUtmRecords: async (params = {}) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", params.page || 1);
    queryParams.append("limit", params.limit || 50);
    
    if (params.utm_source) queryParams.append("utm_source", params.utm_source);
    if (params.utm_campaign) queryParams.append("utm_campaign", params.utm_campaign);
    if (params.utm_medium) queryParams.append("utm_medium", params.utm_medium);
    if (params.user_id) queryParams.append("user_id", params.user_id);
    if (params.start_date) queryParams.append("start_date", params.start_date);
    if (params.end_date) queryParams.append("end_date", params.end_date);
    if (params.platform) queryParams.append("platform", params.platform);

    return await commonRequest(
      "get",
      `${Helpers.URL()}/api/admin/analytics/utm-records?${queryParams.toString()}`,
      {},
      Helpers.token()
    );
  }
};
